<template>
  <div class="w100 bg-w">
    <iframe class="iframe" :src="`/hall/aws/portal/r/w?sid=${userToken}&cmd=com.actionsoft.apps.formui.cachet_home`"></iframe>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OfficeSeal",
  props: [],
  data() {
    return {};
  },
  computed: {
    ...mapState(["userToken"])
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.iframe {
  width: 100%;
  min-height: 680px;
  padding: 20px;
  border: none;
}
</style>
